var map = {
	"./arrow-to-end.svg": 31,
	"./arrow-to-first.svg": 32,
	"./arrow-to-next.svg": 33,
	"./arrow-to-previous.svg": 34,
	"./arrow.svg": 243,
	"./block.svg": 244,
	"./burn.svg": 245,
	"./circulating.svg": 246,
	"./copy-icon.svg": 35,
	"./dashboard.svg": 247,
	"./link.svg": 36,
	"./magnifier.svg": 22,
	"./menu-cancel.svg": 23,
	"./menu.svg": 248,
	"./richaccount.svg": 249,
	"./search.svg": 37,
	"./select.svg": 38,
	"./sns.svg": 250,
	"./transfer.svg": 251,
	"./unwrap.svg": 252
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.svg$
// module id = 30
// module chunks = 0